export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  permission?: string
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    // {
    //   name: 'c_list',
    //   displayName: 'menu.client',
    //   meta: {
    //     icon: 'group',
    //   },
    // },
    {
      name: 'veiculo',
      displayName: 'menu.vehicle',
      meta: {
        icon: 'directions_car',
      },
      children: [
        {
          name: 'v_list',
          displayName: 'menu.available',
        },
        // {
        //   name: 'baixados',
        //   displayName: 'menu.baixados',
        // },
      ],
    },
    {
      name: 'e_list',
      displayName: 'menu.company',
      meta: {
        icon: 'mso-store',
      },
    },
    // {
    //   name: 'venda',
    //   displayName: 'menu.sales',
    //   meta: {
    //     icon: 'mso-money',
    //   },
    //   children: [
    //     {
    //       name: 've_list',
    //       displayName: 'menu.available',
    //     },
    //   ],
    // },
    {
      name: 'u_list',
      displayName: 'menu.user',
      meta: {
        icon: 'mso-manage_accounts',
      },
    },
    // {
    //   name: 'rel_list',
    //   displayName: 'menu.rel',
    //   meta: {
    //     icon: 'mso-assignment',
    //   },
    //   children: [
    //     {
    //       name: 'rel_procuracao',
    //       displayName: 'menu.rel_procuracao',
    //     },
    //   ],
    // },
    // {
    //   name: 'proc_list',
    //   displayName: 'menu.procurador',
    //   meta: {
    //     icon: 'mso-assignment',
    //   },
    //   permission: 'view empresa',
    // },
    {
      name: 'crm',
      displayName: 'menu.crm',
      meta: {
        icon: 'mso-question_answer',
      },
      children: [
        {
          name: 'crm',
          displayName: 'menu.crm',
        },
        {
          name: 'crm-history',
          displayName: 'menu.history',
        },
      ],
    },
    {
      name: 'agenda',
      displayName: 'menu.agenda',
      meta: {
        icon: 'mso-calendar_month',
      },
    },
    {
      name: 'tarefas',
      displayName: 'menu.tarefas',
      meta: {
        icon: 'mso-assignment_turned_in',
      },
    },
    {
      name: 'oportunidades',
      displayName: 'menu.oportunidades',
      meta: {
        icon: 'mso-business_center',
      },
    },
    {
      name: 'negociacao',
      displayName: 'menu.negociacao',
      meta: {
        icon: 'mso-handshake',
      },
      children: [
        {
          name: 'propostas-list',
          displayName: 'menu.propostas',
        },
        {
          name: 'propostas-kanban',
          displayName: 'menu.kanban',
        },
        {
          name: 'propostas-dashboard',
          displayName: 'menu.dashboard_negociacao',
        },
      ],
    },
    {
      name: 'contato',
      displayName: 'menu.contato',
      meta: {
        icon: 'mso-article',
      },
      children: [
        {
          name: 'cont_list',
          displayName: 'menu.contato',
        },
        {
          name: 'tags-list',
          displayName: 'menu.tags',
        },
      ],
    },
    {
      name: 'cliente',
      displayName: 'menu.client',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'template',
      displayName: 'menu.template',
      meta: {
        icon: 'mso-edit',
      },
    },
    {
      name: 'painel',
      displayName: 'menu.painel',
      meta: {
        icon: 'mso-space_dashboard',
      },
    },
    {
      name: 'demos',
      displayName: 'menu.demos',
      meta: {
        icon: 'mso-code',
      },
      permission: 'ver demos',
      children: [
        {
          name: 'lead-contact-demo',
          displayName: 'menu.leadContactDemo',
          permission: 'ver demo leads',
        },
        {
          name: 'lead-test',
          displayName: 'menu.leadTest',
          permission: 'ver demo testes',
        },
      ],
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'mso-settings',
      },
    },
    {
      name: 'businessHour',
      displayName: 'menu.businessHour',
      meta: {
        icon: 'mso-schedule',
      },
    },
  ] as INavigationRoute[],
}
